module.exports = __webpack_public_path__ + "static/img/3bg_7.22f4b69.png";


//////////////////
// WEBPACK FOOTER
// ./static/mycard/background/3bg_7.png
// module id = 700
// module chunks = 1